<template>
  <div>
    <b-loading
      :is-full-page="true"
      :active.sync="isLoading"
      :can-cancel="false"
    ></b-loading>
    <on-board-top-navbar />
    <section class="section">
      <table class="table  is-striped is-narrow is-hoverable is-fullwidth">
        <shared-docs-row
          title="Presentación corporativa de la empresa"
          :files="requestFiles.company_presentation"
        />
        <shared-docs-row
          title="Pitch deck, investor deck, business plan del proyecto o memorándum ejecutivo"
          :files="requestFiles.pitch_deck"
        />
        <shared-docs-row
          title="Dos últimas auditorías o impuestos de sociedades anuales presentados en vigor"
          :files="requestFiles.last_audits"
        />
        <shared-docs-row
          title="Balance de situación y cuentas de explotación actualizadas (del año en curso)"
          :files="requestFiles.account_balance"
        />

        <shared-docs-row
          title="Pool financiero en vigor actualizado (detallado por institución, tipo de deuda e importe)"
          :files="requestFiles.financial_pool"
        />

        <shared-docs-row
          title="Listado de principales clientes (detallado de negocio anual por cliente)"
          :files="requestFiles.main_clients_list"
        />

        <shared-docs-row
          title="Otros documentos de interés mercantil"
          :files="requestFiles.other_merchant_documents"
        />

        <shared-docs-row
          title="Otros hechos relevantes en su actividad"
          :files="requestFiles.other_activity_documents"
        />

        <shared-docs-row
          title="Requerimiento de información adicional"
          :files="requestFiles.aditional_info_documents"
        />

        <shared-docs-row
          title="Otros archivos"
          :files="requestFiles.other_files"
        />
      </table>
    </section>
  </div>
</template>

<script>
import OnBoardTopNavbar from '@/components/on-board/OnBoardTopNavbar'
import SharedDocsRow from '@/components/common/SharedDocsRow.vue'
import { mapActions, mapGetters } from 'vuex'
import Fetcher from '@/mixins/fetcher.js'

export default {
  mixins: [Fetcher],
  props: ['id'],
  components: {
    OnBoardTopNavbar,
    SharedDocsRow
  },
  computed: {
    ...mapGetters('onBoard', ['neofintechData'])
  },
  data: () => ({
    requestFiles: {
      account_balance: [],
      aditional_info_documents: [],
      company_presentation: [],
      financial_pool: [],
      last_audits: [],
      main_clients_list: [],
      other_activity_documents: [],
      other_files: [],
      other_merchant_documents: [],
      pitch_deck: []
    }
  }),
  methods: {
    ...mapActions('onBoard', ['getRequestSharedDocs'])
  },
  beforeMount() {},
  mounted: function() {
    let self = this

    self.request(() =>
      self
        .getRequestSharedDocs({
          requestId: this.id,
          token: self.$route.query.token
        })
        .then(function(response) {
          self.requestFiles = response.data.request_files
          console.log(self.requestFiles)
        })
    )
  },
  beforeDestroy() {
    this.$store.commit('layout/FULL_PAGE', false)
  }
}
</script>

<style>
#app {
  overflow: scroll !important;
}
</style>
